import { BufferWriter, Writer } from "protobufjs";

import { IEntryScoutHistoryRepository } from "../../../domain/repository/entry_scout_history_repository";

import { IApiClient } from "../client";
import { api, common, entity } from "../rpc/api";
import { getToken } from "./bind_token";

class EntryScoutHistoryAPI implements IEntryScoutHistoryRepository {
  constructor(readonly apiClient: IApiClient) {}

  public getAllByClient(
    page: number,
    offset: number,
    isArchive: boolean
  ): Promise<entity.IEntryScoutHistory[]> {
    return new Promise<entity.IEntryScoutHistory[]>((resolve, reject) => {
      getToken()
        .then((token: string): Promise<Uint8Array> => {
          const req: api.IEntryScoutHistoryGetAllRequest =
            new api.EntryScoutHistoryGetAllRequest();
          const pager: common.IPager = new common.Pager();
          pager.page = page;
          pager.offset = offset;
          req.pager = pager;
          req.isArchive = isArchive;
          const writer: BufferWriter | Writer = Writer.create();
          return this.apiClient.postWithToken(
            "/api.EntryScoutHistoryService/GetAll",
            token,
            api.EntryScoutHistoryGetAllRequest.encode(req, writer).finish()
          );
        })
        .then((binary: Uint8Array): void => {
          const res = entity.EntryScoutHistoryList.decode(binary);
          resolve(res.items);
        })
        .catch((error: Error): void => {
          reject(error);
        });
    });
  }

  public toggleArchive(
    projectId: string,
    customerId: string,
    isArchive: boolean
  ): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      getToken()
        .then((token: string): Promise<Uint8Array> => {
          const req: api.IEntryScoutHistoryToggleArchiveRequest =
            new api.EntryScoutHistoryToggleArchiveRequest();
          req.projectID = projectId;
          req.customerID = customerId;
          req.isArchive = isArchive;
          const writer: BufferWriter | Writer = Writer.create();
          return this.apiClient.postWithToken(
            "/api.EntryScoutHistoryService/ToggleArchive",
            token,
            api.EntryScoutHistoryToggleArchiveRequest.encode(
              req,
              writer
            ).finish()
          );
        })
        .then((binary: Uint8Array): void => {
          resolve();
        })
        .catch((error: Error): void => {
          reject(error);
        });
    });
  }
}

const createEntryScoutHistoryAPI = (
  apiClient: IApiClient
): IEntryScoutHistoryRepository => {
  return new EntryScoutHistoryAPI(apiClient);
};

export { createEntryScoutHistoryAPI };



// WEBPACK FOOTER //
// ./src/infra/api/service/entry_scout_history_api.ts